// src/components/Login.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import "../styles/login.css";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  // Ako je korisnik već prijavljen → odmah na admin panel
  useEffect(() => {
    const session = localStorage.getItem("sb_session");
    if (session) navigate("/admin");
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("⏳ Prijava...");

    if (!form.email || !form.password) {
      return setMsg("❌ Molimo unesite email i lozinku.");
    }

    const { data, error } = await supabase.auth.signInWithPassword({
      email: form.email,
      password: form.password,
    });

    if (error) {
      console.error("Login error:", error);
      return setMsg("❌ " + error.message);
    }

    // Spremaj session
    if (data.session) {
      localStorage.setItem("sb_session", JSON.stringify(data.session));
    }

    setMsg("✅ Uspješna prijava! Preusmjeravanje...");

    setTimeout(() => navigate("/admin"), 800);
  };

  return (
    <div className="login-page">
      <h1>🔑 Admin prijava</h1>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
        />

        <input
          type="password"
          placeholder="Lozinka"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
        />

        <button type="submit">Prijavi se</button>
      </form>

      {msg && <p className="status-msg">{msg}</p>}
    </div>
  );
}
